<template>
  <div class="left">
    <ul class="box">
      <li
        v-if="$router.history.current.query.type === '2' && detailsData.data.payUrl"
        @click="openBuy(detailsData.data.payUrl)"
      >
        <img src="@/assets/img/details/buy.png" alt />
        <div>购买</div>
      </li>
      <li @click="signUp" v-if="this.$route.query.goodsId && this.$route.query.goodsId != null">
        <img src="@/assets/img/details/signUp.png" alt />
        <div>报名</div>
      </li>
      <li @click="collect">
        <img v-if="isCollect" src="@/assets/img/details/1.png" alt />
        <img v-else src="@/assets/img/details/2.png" alt />
        <!--        <img v-lazy="isCollect?`@/assets/img/details/1.png`:`@/assets/img/details/2.png`" alt="" />-->
        <!--        <img src="@/assets/img/details/1.png" alt="">-->
        <!--        <img src="@/assets/img/details/2.png" alt="">-->
        <div>收藏</div>
      </li>
      <li
        v-if="
          !(
            $router.history.current.query.type === '2' ||
            $router.history.current.query.type === '5' ||
            $router.history.current.query.type === '7' ||
            $router.history.current.query.type === '8' ||
            $router.history.current.query.type === '10' ||
            !$router.history.current.query.type
          )
        "
        @click="downPdf"
      >
        <img src="@/assets/img/details/download.png" alt />
        <div>下载</div>
      </li>

      <Button
        v-if="
          !(
            $router.history.current.query.type == '2' ||
            $router.history.current.query.type == '5' ||
            $router.history.current.query.type == '7' ||
            $router.history.current.query.type == '8'
          )
        "
        v-throttleClick
        @click="read"
        class="readBtn"
      >
        <div v-if="$router.history.current.query.type && $router.history.current.query.type != '10'">
          <img src="@/assets/img/details/onlineReading.png" alt />
          <div>在线阅读</div>
        </div>
        <div v-else>
          <div @click.stop="toUrl">
            <img src="@/assets/img/details/onlineReading.png" alt />
            <div>
              <a style="color: #666666" target="_blank">在线投稿</a>
            </div>
          </div>
        </div>
      </Button>

      <!--      <li>-->
      <!--        <img src="@/assets/img/details/peerReview.png" alt="" />-->
      <!--        <div>同行评议</div>-->
      <!--      </li>-->



      <li class="share">
        <img src="@/assets/img/details/share.png" alt />
        <div>分享</div>
        <ul class="share_box">
          <div class="sanjiao"></div>
          <li @mouseover.stop="weChat" class="weChat">
            <img src="@/assets/img/details/WeChat.png" alt />
            <div>微信</div>
            <div id="WXqrcode" ref="WXqrcode" class="ma"></div>
          </li>
          <li @click="weibo">
            <img src="@/assets/img/details/weiBo.png" alt />
            <div>新浪微博</div>
          </li>
          <li @mouseover.stop="qq" class="qq">
            <img src="@/assets/img/details/QQ.png" alt />
            <div>QQ</div>
            <div id="QQqrcode" ref="QQqrcode" class="ma"></div>
          </li>
          <li @click="space">
            <img src="@/assets/img/details/qqspace.png" alt />
            <div>QQ空间</div>
          </li>
        </ul>
      </li>
    </ul>
    <Modal v-model="qrCodeModal" title="手机查看完整会议内容" class="" @on-cancel="qrCodeModal = false" :footer-hide="true">
      <div style="width:200px;height:200px;margin:20px auto;">
        <div id="qrcodeArea" ref="qrcodeArea">
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";

export default {
  name: "left",
  props: ["detailsData"],
  data() {
    return {
      WXurl: "",
      QQurl: "",
      isCollect: false,
      qrCodeModal:false,
    };
  },
  computed: {
    ...mapState(["hasLogin"]),
  },
  watch: {
    detailsData() {
      // this.weChat();
      // this.qq();
      if (this.hasLogin) {
        this.TFCollect();
      }
    },
  },
  created() {
    if (this.hasLogin) {
      this.TFCollect();
    }
  },
  methods: {
    toUrl() {
      let id = sessionStorage.getItem("perId");
      if (sessionStorage.getItem("token")) {
        if (localStorage.getItem("close")) {
          window.open(`https://www.baikezaixian.com/details?ids=${id}`);
        } else {
          this.$bus.$emit("toBJUrl", id);
        }
      }
    },
    openBuy(url) {
      window.open(url)
    },
    // tougao() {
    //   window.open(
    //     `http://www.baikezaixian.com/details?ids=${
    //       this.detailsData.perId ? this.detailsData.perId : ""
    //     }`,
    //     "_blank"
    //   );
    // },
    async downPdf() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.download +
          "?articleId=" +
          this.$router.history.current.query.id +
          "&articleType=" +
          this.$router.history.current.query.type +
          "&token=" +
          sessionStorage.getItem("token")
      );
    },
    signUp(){
      this.qrCodeModal = true;
      this.$nextTick(() => {
          // 生成H5
          if (!this.qr) {
            this.qr = new QRCode(this.$refs.qrcodeArea, {
              width: 200,
              height: 200, // 高度
              text: window.location.href, // 二维码内容
            });
          }
        })
    },
    async collect() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        action: this.isCollect ? 0 : 1,
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type
          ? this.$router.history.current.query.type
          : 10,
      };
      let res = await this.$apis.recomendServe.CollectItem(obj);
      await this.TFCollect();
    },
    async TFCollect() {
      let obj = {
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type
          ? this.$router.history.current.query.type
          : 10,
      };
      let res = await this.$apis.recomendServe.isCollect(obj);
      this.isCollect = res.isCollect;
    },
    async read() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.readUrl +
          "?articleId=" +
          this.$router.history.current.query.id +
          "&articleType=" +
          this.$router.history.current.query.type +
          "&token=" +
          sessionStorage.getItem("token")
      );
    },
    getUrl(isPC = false) {
      let url = "";
      if (this.detailsData.articleType === 0) {
        // 论文
        url =
          this.$global.url1 +
          `${isPC ? "thesisDetail" : "thesisDetail"}?type=${
            this.detailsData.articleType
          }&id=${this.detailsData.data.id}`;
      } else if (this.detailsData.articleType === 6) {
        // 报告
        url =
          this.$global.url1 +
          `${isPC ? "dataDetails" : "dataDetails"}?type=${
            this.detailsData.articleType
          }&id=${this.detailsData.data.id}`;
      } else if (this.detailsData.articleType === 5) {
        // 资讯
        url =
          this.$global.url1 +
          `${isPC ? "msgDetails" : "msgDetails"}?type=${
            this.detailsData.articleType
          }&id=${this.detailsData.data.id}`;
      } else if (this.detailsData.articleType == 2) {
        // 专著
        url =
          this.$global.url1 +
          `${isPC ? "concentrationDetails" : "concentrationDetails"}?type=${
            this.detailsData.articleType
          }&id=${this.detailsData.data.id}`;
      } else if (this.$router.history.current.query.type == 8) {
        // 会议
        url =
          this.$global.url1 +
          `${isPC ? "meetingDetails" : "meetingDetails"}?id=${
            this.detailsData.data.id
          }`;
      } else {
        // 征稿函
        url =
          this.$global.url1 +
          `${isPC ? "solicitationDetails" : "solicitationDetails"}?id=${
            this.detailsData.id
          }&type=10`;
      }
      return url;
    },
    weChat() {
      if (this.WXurl !== "") return;
      this.WXurl = this.getUrl();

      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.WXcrateQrcode();
      });
    },
    WXcrateQrcode() {
      this.qr = new QRCode("WXqrcode", {
        width: 150,
        height: 150, // 高度
        text: this.WXurl, // 二维码内容
      });
    },
    QQcrateQrcode() {
      this.qr = new QRCode("QQqrcode", {
        width: 150,
        height: 150, // 高度
        text: this.QQurl, // 二维码内容
      });
    },
    qq() {
      if (this.QQurl !== "") return;
      this.QQurl = this.getUrl();

      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.QQcrateQrcode();
      });
    },
    weibo() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      let srcTitle = "";
      this.detailsData.data && this.detailsData.data.cover
        ? (srcUrl = `pic=${this.$global.imgUrl + this.detailsData.data.cover}&`)
        : (srcUrl = "");
      this.detailsData.data && this.detailsData.data.title
        ? (srcTitle = `&title=${this.detailsData.data.title}`)
        : (srcTitle = "");
      window.open(
        `https://service.weibo.com/share/share.php?${srcUrl}url=${url}${srcTitle}&ralateUid=7679917329`
      );
    },
    space() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      let srcTitle = "";
      this.detailsData.data && this.detailsData.data.cover
        ? (srcUrl = `pics=${
            this.$global.imgUrl + this.detailsData.data.cover
          }&`)
        : (srcUrl = "");
      this.detailsData.data && this.detailsData.data.title
        ? (srcTitle = `&title=${this.detailsData.data.title}`)
        : (srcTitle = "");
      window.open(
        `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${srcUrl}url=${url}${srcTitle}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.left {
  width: 120px;
  //background: pink;
  height: 600px;

  .box {
    display: flex;
    margin-top: 51px;
    flex-direction: column;
    justify-content: space-around;

    li {
      width: 120px;
      //background: yellow;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-bottom: 44px;
      cursor: pointer;
      img {
        width: 28px;
        height: 28px;
        margin-bottom: 3px;
      }
      div {
        text-align: center;
        width: 120px;
        font-size: 12px;
        //font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
    }
    .readBtn {
      border: none;
      width: 100%;
      height: 100%;
      margin-bottom: 44px;
      img {
        width: 28px;
        height: 28px;
        margin-bottom: 3px;
      }

      div {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }
      &:focus {
        box-shadow: none !important;
      }
    }

    .share:hover {
      .share_box {
        display: block;
      }
    }

    .share {
      z-index: 10;
      position: relative;

      .share_box {
        cursor: pointer;
        display: none;
        right: -120px;
        position: absolute;
        width: 133px;
        height: 167px;
        background: #ffffff;
        box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
        border-radius: 10px;

        .weChat:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }

        .weChat {
          position: relative;

          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -10px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
          }
        }

        .qq:hover {
          .ma {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }

        .qq {
          position: relative;

          .ma {
            display: none;
            left: 123px !important;
            position: absolute !important;
            width: 200px !important;
            top: -90px !important;
            height: 167px !important;
            background: white !important;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
          }
        }

        li {
          margin-top: 10px;
          margin-bottom: 0px;
          //display: flex;
          flex-wrap: nowrap;
          //background: pink;
          justify-content: center;
          align-items: center;
          width: 133px;
          height: 30px;

          div {
            width: 60px;
            //background: yellow;
            margin-left: 10px;
          }

          img {
            width: 20px;
            height: 20px;
          }
        }

        .sanjiao {
          width: 0;
          height: 0;
          border-top: 3px solid transparent;
          border-right: 6px solid #fff;
          position: absolute;
          top: 50%;
          margin-top: -3px;
          left: -6px;
          border-bottom: 3px solid transparent;

          //background: pink;
        }
      }
    }
  }
}
</style>
